export enum DanceEventRelationsEnum {
  COHOSTS = 'COHOSTS',
}
